import { StyleSheet } from 'react-native';

/** 创建样式 */
export const createStyles = (fontSize: number, lineHeight?: number) => {
    const computedLineHeight = lineHeight || fontSize * 1.4;
    
    return StyleSheet.create({
        // 容器
        container: {
            flexDirection: 'row',
            flexWrap: 'wrap',
            alignItems: 'flex-start',
        },
        // 可点击容器
        pressable: {
            flexDirection: 'row',
            flexWrap: 'wrap',
            alignItems: 'flex-start',
        },
        // 标题文本
        title: {
            fontSize,
            lineHeight: computedLineHeight,
            color: '#333333',
            fontWeight: '500',
        },
        // 前置标签容器
        prefixTagContainer: {
            flexDirection: 'row',
            alignItems: 'center',
            flexWrap: 'wrap',
        },
        // 后置标签容器
        suffixTagContainer: {
            flexDirection: 'row',
            alignItems: 'center',
            flexWrap: 'wrap',
        },
        // 内联标签
        inlineTag: {
            paddingHorizontal: 4,
            paddingVertical: 1,
            borderRadius: 2,
            borderWidth: 1,
        },
        inlineTagText: {
            fontSize: 10,
            fontWeight: '500',
        },
        // 高亮文字
        highlight: {
            color: '#FF2442',
        },
    });
};

/** 默认标签样式 */
export const DEFAULT_TAG_STYLE = {
    paddingHorizontal: 4,
    paddingVertical: 1,
    borderRadius: 2,
    fontSize: 10,
};
